$('.gallery-slider').slick({
	infinite: true,
	slidesToShow: 1, 
	prevArrow: '.gallery-prev',
	nextArrow: '.gallery-next',
	autoplay: true,
  	autoplaySpeed: 3000,
	dots: true,
	appendDots: '.gallery-dots',
	adaptiveHeight: true,
});

$('.project-single__slider').slick({
	infinite: true,
	slidesToShow: 1, 
	prevArrow: '.project-single__prev',
	nextArrow: '.project-single__next',
	autoplay: true,
  	autoplaySpeed: 3000,
	// код для центрированного slick slider

	centerMode: true,
	centerPadding: '500px',

	// код для адаптива slick slider
	responsive: [
    {
      breakpoint: 1700,
      settings: {
        centerPadding: '400px',
      }
    },
	{
		breakpoint: 1500,
		settings: {
		  centerPadding: '300px',
		}
	},
	{
		breakpoint: 1200,
		settings: {
		  centerPadding: '200px',
		}
	},
	{
		breakpoint: 1000,
		settings: {
		  centerPadding: '100px',
		}
	},
	{
		breakpoint: 700,
		settings: {
		  centerPadding: '40px',
		}
	},
  ]

});

$('.language-active').click(function(e) {
	e.preventDefault();
	$(this).siblings('.language-drop').slideToggle();
});

$('.project-tab').click(function(e) {
	e.preventDefault();
	let projectItem = $(this).data('project');
	$('.project-tab').removeClass('project-tab_active');
	$(this).addClass('project-tab_active');
	$('.project-wrap').hide();
	$('.project-wrap[data-project = ' + projectItem +']').css("display", "grid").hide().fadeIn();
});

$('.burger').click(function(e) {
	e.preventDefault();
	$('.mob-menu-frame').fadeIn();
	$('.mob-menu').addClass('mob-menu_active');
});

$('.mob-close').click(function(e) {
	e.preventDefault();
	$('.mob-menu-frame').fadeOut();
	$('.mob-menu').removeClass('mob-menu_active');
});

$(".mob-menu-frame").click(function (e){ // событие клика по веб-документу
	var popup = $(".mob-menu"); // тут указываем ID элемента
	if (!popup.is(e.target) // если клик был не по нашему блоку
		&& popup.has(e.target).length === 0) { // и не по его дочерним элементам
			$('.mob-menu-frame').fadeOut();
			$('.mob-menu').removeClass('mob-menu_active');
	}
});


var header = $('.header'),
	scrollPrev = 0;

$(window).scroll(function() {
	var scrolled = $(window).scrollTop();
 
	if ( scrolled > 40 && scrolled > scrollPrev && $(window).width() < 900 && $(window).height() < 400) {
		header.addClass('out');
	} else {
		header.removeClass('out');
	}
	scrollPrev = scrolled;
});